/* eslint-disable @typescript-eslint/ban-ts-ignore */
import { Decorator, FormApi, Mutator } from 'final-form'
import React from 'react'
import { Form as FinalForm } from 'react-final-form'
import { toast } from 'react-toastify'
import { Color } from '../../config/theme'
import Button, { Props as ButtonProps } from '../Button'
import Loader from '../Loader'
import Field from './Fields'
import FieldType from './Fields/type'
import { FieldContainer, StyledForm } from './styles'


interface Props<T extends {}> {
  buttonLabel?: string
  buttonColor?: Color
  initialValues?: T
  fields: FieldType<keyof T & string>[]
  keys?: (keyof T | string)[]
  onSubmit: (data: T, form: FormApi<T>) => void
  horizontal?: boolean
  hasSubmitButton?: boolean
  buttonProps?: Partial<ButtonProps>
  mutators?: { [key: string]: Mutator<any> }
  decorators?: Decorator<any>[]
  customData?:any
}

const Form = <T extends {}>({
  buttonLabel = 'Salvar',
  mutators,
  decorators,
  buttonColor,
  initialValues,
  fields,
  keys,
  horizontal,
  buttonProps,
  onSubmit,
  hasSubmitButton = true,
  customData,
}: Props<T>) => {
  const _onSubmit = (values: T, form: FormApi<T>) => {
    if (keys) {
      for (const key of keys) {
        // @ts-ignore
        if (!values[key]) {
          // @ts-ignore
          values[key] = ''
        }
      }
      for (const key of form.getRegisteredFields()) {
        // @ts-ignore
        if (!values[key]) {
          // @ts-ignore
          values[key] = null
        }
      }
    }
    return onSubmit(values, form)
  }

  return (
    <FinalForm
      validateOnBlur={true}
      decorators={decorators}
      mutators={mutators}
      keepDirtyOnReinitialize={false}
      initialValues={initialValues}
      onSubmit={_onSubmit}
    >
      {({ form, values, submitting, handleSubmit }) => (
        <StyledForm
          onSubmit={handleSubmit}
          horizontal={horizontal}
        >
          {fields.map((field, i) => (!field.only || field.only(values)) && (
            <Field
              key={i}
              field={field}
            />
          ))}

          { customData }

          <FieldContainer>
            {hasSubmitButton && (<Button
              label={buttonLabel}
              disabled={submitting}
              backgroundColor={buttonColor}
              type="submit"
              onClick={() => {
                if (form.getState().hasValidationErrors) {
                  toast.error('Verifique os campos e tente novamente')
                }
              }}
              {...buttonProps}
            />)
            }
          </FieldContainer>

          {submitting && (
            <Loader
              full
            />
          )}
        </StyledForm>
      )}
    </FinalForm>
  )
}

export default Form
